import { widgetManager } from '../../utils';
import { initTracer } from '../../utils/initTracer';

import { isDevelopment } from '../../../config';

if (!isDevelopment) {
  initTracer();
}

// Добавляем widgetManager в глобальную область видимости
window.widgetManager = widgetManager;

widgetManager.init();
